import React, { Component } from 'react'
import { Row, Col, Radio, Icon, Select, Modal, Button, Spin } from 'antd'
import { app } from '../../app'
import MSendRecord from './MSendRecord'
import MOverview from './MOverview'
import MBuy from './MBuy'
import MSend from './MSend'
import MSset from './MSset'
import { getProvinceList, getTeamList, getSMSmsManage, getSMBDInfo, getSMjoinTeamInfo } from './message_api'
import '../../css/message.css'

const Option = Select.Option

class Message extends Component {








    // 组件内部
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            team_loading: false,
            province_loading: false,
            ct_visible: false,
            sub_type: null,
            teamInfo: {
                key: null,
                text: '点击选择查看对象',
                type: null,
            },
            provinceList: [],
            teamList: [],
            edit_team: undefined,
            edit_province: undefined,
            has_edit: true,
            // 生日短信模板
            //MessageTemplate: [],
            // 入职短信模板
            MessageTemplate: [],
            pggcj: '',
            //队伍信息，来自componentDidMount中获取
            team: {
                key: null,
                text: '点击选择查看对象',
                type: null,
            },
            // 生日短信模板设置
            SMBDInfo: {},
            joinTeamEditInfo: {}
        }
        // 获取 生日、入职 两个短信模板列表信息
        this.getMSTemplate(this.state.teamInfo)
        this.getMSTemplate2(this.state.teamInfo)

        // 获取生日短信模板设置
        this.getSMBDEditInfo(this.state.teamInfo)
        this.getSMjoinTeamEditInfo(this.state.teamInfo)
    }











    // 生命周期
    async componentDidMount() {
        this._isMounted = true
        const provinceList = await getProvinceList()
        // 全国地区列表
        // console.log(provinceList)

        await this.setData({ provinceList, province_loading: false })
        if (provinceList.length === 1) {

            const teamList = await this.handleLoadTeamData(provinceList[0])

            // console.log(teamList)

            if (teamList.length === 1) {
                const teamInfo = {
                    key: teamList[0].value,
                    text: teamList[0].label,
                    type: teamList[0].type,
                    _p: provinceList[0]
                }

                await this.setData({
                    teamInfo, sub_type: '1', ct_visible: false, has_edit: false, loading: false
                })
                // 获取 生日、入职 两个短信模板列表信息
                await this.getMSTemplate(teamInfo)
                await this.getMSTemplate2(teamInfo)

                    // 获取生日短信模板设置
                await this.getSMBDEditInfo(teamInfo)
                await this.getSMjoinTeamEditInfo(teamInfo)
                app.setData('message-select-team-info', teamInfo)
                return
            }
        }
        // console.log("执行到了这里*9")
        const msti = app.getData('message-select-team-info')
        if (typeof msti === 'object' && provinceList.indexOf(msti._p) !== -1) {
            const teamList = await this.handleLoadTeamData(msti._p)
            if (teamList.findIndex(team => team.value === msti.key) !== -1) {
                // console.log(msti)
                if (msti.type == 1) {
                    // 获取 生日、入职 两个短信模板列表信息
                    await this.getMSTemplate(msti)
                    await this.getMSTemplate2(msti)

                    // 获取生日短信模板设置
                    await this.getSMBDEditInfo(msti)
                    await this.getSMjoinTeamEditInfo(msti)
                }

                this.setData({
                    teamInfo: msti, sub_type: '1', ct_visible: false, loading: false, team: msti
                })
                // console.log(this.props.location.state)
                // if(this.props.location.state){
                //     console.log("存在")
                // }else{
                //     console.log("不存在")
                // }

                //  来自首页的跳转，主要是为了进行新功能展示,(当出现新功能后删除第一段代码块)
                if (this.props.location.state) {
                    // console.log(msti)
                    if (msti.type != 1) {
                        // console.log("zz")
                        this.setState({
                            ct_visible: true
                        })

                    } else {
                        this.setData({
                            teamInfo: msti, sub_type: this.props.location.state.routerCom, ct_visible: false, loading: false, team: msti
                        })
                    }



                    // console.log(this.props.location.state)

                } else {
                    this.setData({
                        teamInfo: msti, sub_type: '1', ct_visible: false, loading: false, team: msti
                    })
                }

                return
            }
        }
        await this.setData({ ct_visible: true, loading: false })


        app.removeData('message-select-team-info')


    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)























    // 方法函数

    /**
     * 修改标题
     * @param sub_type
     * @returns {Promise<void>}
     */
    handleChangeSub = async (sub_type) => {
        // console.log("开始修改队伍")

        await this.setData({ sub_type })
    }

    /**
     * 选择队伍/省份
     * @param e
     * @returns {Promise<boolean>}
     */
    handleChangeTeam = async (e) => {
        // console.log(e)
        // 重新执行 DidMount 获取数据
        this.componentDidMount()


        const { teamInfo, edit_team, teamList, sub_type, edit_province } = this.state
        console.log("当前队伍为" + teamInfo.type)
        // 如果未选择队伍提示用户
        if (!edit_team) {
            app.alert('请选择队伍', 'warn')
            return false
        }

        // 如果选择相同队伍返回
        if (teamInfo.key === edit_team) {
            if(this.props.location.state && teamInfo.type != 1){
                app.alert('【短信设置】功能，请选择队伍进行设置', 'warn')
            }
            return false
        }
        // 只要用户选择了新队伍都跳转回概述

        this.setData({ sub_type: '1' })
        // 获取到选择的队伍信息
        const value = teamList.filter(t => t.value === edit_team)[0]
        // console.log(value)

        const teamInfo2 = { key: value.value, text: value.label, type: value.type, _p: edit_province }
        await this.setData({
            teamInfo: teamInfo2,
            ct_visible: false,
            // sub_type: sub_type || '1'
        })
        console.log("当前队伍为" + teamInfo.type)

        if(this.props.location.state && teamInfo2.type != 1){
            app.alert('【短信设置】功能，请选择队伍进行设置', 'warn')
        }

        app.setData('message-select-team-info', teamInfo2)
        return true
    }

    // 获取生日短信模板列表
    async getMSTemplate(msti) {

        // 从父组件中发起请求
        // if(this.state.getSMSmsManageflag){
        //     return
        // }
        // console.log(this.state.team)
        const team = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            object_name: msti.key,
            type: 1
        }
        const data = await getSMSmsManage(team)


        this.setData({
            MessageTemplate: data,
        })
        // console.log(this.state.MessageTemplate)
    }

    // 获取入职短信模板列表
    async getMSTemplate2(msti) {

        // 从父组件中发起请求
        // if(this.state.getSMSmsManageflag){
        //     return
        // }
        const team = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            object_name: msti.key,
            type: 2
        }
        const data = await getSMSmsManage(team)


        this.setData({
            MessageTemplate2: data,
        })
        // console.log(this.state.MessageTemplate2)
    }


    // getSMBDInfo
    // 获取生日短信模板设置
    async getSMBDEditInfo(msti) {
        // console.log("获取生日短信模板设置")
        // console.log(this.state);
        if(msti.type == 1){
            const team = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                object_name: msti.key,
            }

            const data = await getSMBDInfo(team)
            const { MessageTemplate } = this.state
            MessageTemplate.forEach((item, index) => {
                if (item.template_code == data.template_code) {
                    data.templateIndex = index
                }
            })
            // console.log(data)
            // data.volunteer_state = data.volunteer_state.split(',')  //已经处理好了SMBDInfo

            this.setData({
                SMBDInfo: data
            })
        }

    }

    // getSMjoinTeamInfo
    // 获取入职短信模板设置
    async getSMjoinTeamEditInfo(msti) {
        if(msti.type == 1){
            const team = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                object_name: msti.key,
            }

            const data = await getSMjoinTeamInfo(team)
            const { MessageTemplate2 } = this.state
            if(MessageTemplate2 != ''){
                MessageTemplate2.forEach((item, index) => {
                    if (item.template_code == data.template_code) {
                        data.templateIndex = index
                    }
                })
            }

            this.setData({
                joinTeamEditInfo: data
            })
        }

    }


    // 一进入短信管理页面就会触发
    /**
     * 加载队伍
     * @param value
     * @returns {Promise<void>}
     */
    handleLoadTeamData = async value => {
        // console.log(12312345)
        await this.setData({ team_loading: true })
        //队伍列表
        const teams = await getTeamList(value)
        const teamList = teams.map(t => {
            return {
                value: t.object_name,
                label: t.name,
                type: t.type
            }
        })


        // 获取 生日 的模板设置信息(获取已有的设置)

        await this.setData({ edit_province: value, edit_team: undefined, teamList, team_loading: false })
        return teamList
    }

    // MessageTemplate={MessageTemplate} MessageTemplate2={MessageTemplate2} SMBDInfo={SMBDInfo} joinTeamEditInfo={joinTeamEditInfo}

    getMessageInfo = async () => {

        // console.log(this.state)
        // 获取生日短信模板设置
        // this.getSMBDEditInfo(this.state.team)
        // this.getSMjoinTeamEditInfo(this.state.team)

    }




































    // 页面渲染区
    render() {
        let { sub_type, teamInfo, teamList, provinceList, ct_visible, edit_province, edit_team, team_loading, province_loading, has_edit, loading, MessageTemplate, MessageTemplate2, SMBDInfo, joinTeamEditInfo } = this.state
        let content_node = null, sub_title = '请先选择查看对象'
        switch (sub_type) {
            case '1':
                sub_title = '短信服务概览'
                content_node = (<MOverview team={teamInfo} changeSub={this.handleChangeSub} />)
                break
            case '2':
                sub_title = '国内短信套餐包'
                content_node = (<MBuy team={teamInfo} changeSub={this.handleChangeSub} />)
                break
            case '3':
                sub_title = '在线发送短信'
                content_node = (<MSend team={teamInfo} changeSub={this.handleChangeSub} />)
                break
            case '4':
                sub_title = '发送记录查询'
                content_node = (<MSendRecord team={teamInfo} />)
                break
            case '5':
                sub_title = '短信设置'
                content_node = (<MSset team={teamInfo}
                    birthdayMessageTemplate={MessageTemplate}
                    joinTeamMessageTemplate={MessageTemplate2}
                    SMBDInfo={SMBDInfo}
                    joinTeamEditInfo={joinTeamEditInfo}
                />)
                break
        }
        return (
            <div className="message-page">
                <Spin spinning={loading}>
                    <Row type="flex" justify="space-between">
                        <Col>
                            <div className="mp-title">{sub_title}</div>
                            <span className="mp-teamlink" onClick={() => {
                                has_edit && this.setData({ ct_visible: true })
                            }}>
                                {teamInfo.type === 1 ? (<span className="pt-icon">队</span>) : (teamInfo.type === 2 ? (<span className="pt-icon">省</span>) : (teamInfo.type === 3 ? (<span className="pt-icon">国</span>) : ''))}
                                {teamInfo.text}
                                {has_edit ? (<Icon type="edit" />) : null}
                            </span>
                        </Col>

                        <Col hidden={!teamInfo.key} spinning={loading}>
                            <Radio.Group value={sub_type} buttonStyle="solid" className="no-select"
                                onChange={(e) => this.setData({ sub_type: e.target.value })} >
                                <Radio.Button value="1" onClick={this.getMessageInfo}>概览</Radio.Button>
                                <Radio.Button value="2" onClick={this.getMessageInfo}>购买套餐</Radio.Button>
                                <Radio.Button value="3" onClick={this.getMessageInfo}>在线发送</Radio.Button>
                                <Radio.Button value="4" onClick={this.getMessageInfo}>发送记录</Radio.Button>
                                {/* <Radio.Button value="5">短信设置</Radio.Button> */}
                                {teamInfo.type === 1 ? (<Radio.Button value="5"  >短信设置</Radio.Button>) : ''}
                            </Radio.Group>
                        </Col>
                    </Row>
                    {content_node}
                </Spin>
                <Modal
                    title={(<div style={{ textAlign: 'center' }}>选择查看对象</div>)}
                    visible={ct_visible}
                    width={400}
                    centered={true}
                    onCancel={() => this.setData({ ct_visible: false })}
                    maskClosable={false}
                    destroyOnClose={true}
                    footer={(
                        <Button type="primary" disabled={!edit_team} onClick={this.handleChangeTeam} block>确定</Button>
                    )}
                >
                    <div>
                        <Select
                            style={{ width: 120 }}
                            value={edit_province}
                            placeholder="选择省份"
                            optionFilterProp="children"
                            showSearch={true}
                            onChange={this.handleLoadTeamData}
                            notFoundContent={province_loading ? (<Spin size="small" />) : '暂无数据'}
                        >
                            {
                                provinceList.map(p => (
                                    <Option key={encodeURIComponent(p)} value={p}>{p}</Option>
                                ))
                            }
                        </Select>

                        <Select
                            style={{ width: 217, marginLeft: 15 }}
                            value={edit_team}
                            placeholder="选择队伍"
                            optionFilterProp="children"
                            onChange={(value) => this.setData({ edit_team: value })}
                            notFoundContent={team_loading ? (<Spin size="small" />) : '暂无数据'}
                            showSearch={true}
                            disabled={!edit_province}
                        >
                            {
                                teamList.map(t => {
                                    return (
                                        <Option key={t.value} value={t.value}>{t.label}</Option>
                                    )
                                })
                            }
                        </Select>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default Message



// WEBPACK FOOTER //
// ./src/routes/message/Message.jsx